import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Necesito experiencia previa en costura?',
  a: '¡Para nada! El Tomo 1 está diseñado específicamente para principiantes, con un paso a paso ilustrado muy fácil de seguir. Empezamos desde lo más básico.'
}, {
  q: '¿Cómo recibo los moldes?',
  a: 'Al confirmar tu pago, recibirás inmediatamente un correo electrónico con el enlace para acceder y descargar todos los tomos y bonos en formato PDF.'
}, {
  q: '¿Sirve para perros y gatos?',
  a: 'Sí, los moldes están diseñados y adaptados para la anatomía tanto de perros como de gatos.'
}, {
  q: '¿Qué tamaños incluye?',
  a: 'Todos nuestros moldes vienen escalados en diferentes talles, desde XS para mascotas muy pequeñas hasta XL para razas más grandes.'
}, {
  q: '¿Puedo vender la ropa que haga con estos moldes?',
  a: '¡Por supuesto! De hecho, incluimos un bono especial sobre cómo emprender y vender tus creaciones por Instagram.'
}, {
  q: '¿Cuánto tiempo tengo acceso?',
  a: 'El acceso es de por vida. Pagás una sola vez y podés descargar el material las veces que quieras, para siempre.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-24 bg-brand-cream-light" data-id="element-85">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-86">
        <div className="text-center mb-12" data-id="element-87">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-88">
            Preguntas <span className="text-brand-rose" data-id="element-89">frecuentes</span>
          </h2>
        </div>

        <div className="space-y-4" data-id="element-90">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-2xl overflow-hidden shadow-sm border border-brand-cream-mid" data-id="element-91">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" aria-expanded={openIndex === index} data-id="element-92">
                <span className="font-bold text-lg pr-4" data-id="element-93">{faq.q}</span>
                <ChevronDown className={`shrink-0 text-brand-rose transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-94" />
              </button>

              <AnimatePresence data-id="element-95">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-96">
                    <div className="px-6 pb-5 text-brand-brown/80 leading-relaxed" data-id="element-97">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}